export const fieldsForSearchService = {
  date1: {
    key: "date1",
    label: "Период отчета с",
    type: "date",
    disabled: false,
    required: true,
    hidden: false,
  },
  date2: {
    key: "date2",
    label: "Период отчета по",
    type: "date",
    disabled: false,
    required: true,
    hidden: false,
  },
  report: {
    key: "report",
    label: "Услуга или процедура",
    type: "selectSearch",
    disabled: false,
    search: false,
    required: true,
    placeholder: "Выберите",
    options: [
      {
        key: "report",
        value: ["2", "1"],
        label: "Выполненные административные процедуры",
        description:
          "В отчете по выполненным административным процедурам отражаются те заявители, по которым пришли сведения из ЕРИП об оплате и зарегистрировано заявление",
      },
      {
        key: "report",
        value: ["2", "2"],
        label: "Оплаченные административные процедуры",
        description:
          "В отчете по оплаченным административным процедурам отражаются только те лица, по которым пришли сведения из ЕРИП об оплате, но заявление не зарегистрировано",
      },
      {
        key: "report",
        value: ["1", "1"],
        label: "Платные услуги  по выставленным счетам",
        description:
          "В данный отчет включены те заявители, которым при регистрации заявления выставили QR-код для оплаты, и они по нему оплатили",
      },
      {
        key: "report",
        value: ["1", "2"],
        label: "Платные услуги без выставления счета",
        description:
          "В данный отчет включены те заявители, которым при регистрации заявление не выставляли QR-код для оплаты",
      },
    ],
    hidden: false,
    description: true,
  },
  section: {
    key: "section",
    label: "Участок",
    type: "selectSearch",
    disabled: false,
    required: false,
    search: true,
    options: [],
    hidden: false,
    placeholder: "Все",
  },
  oblast: {
    key: "oblast",
    label: "Область",
    type: "selectSearch",
    disabled: false,
    search: false,
    required: false,
    placeholder: "Все",
    options: [],
    hidden: false,
  },
};

export const setOptionsForField = (prop, field) => {
  switch (field) {
    case "firstInit": {
      fieldsForSearchService.oblast.options = prop?.filter((el) => el.id !== 5);
      break;
    }
    case "optionsForSection": {
      fieldsForSearchService.section.options = prop;
      break;
    }
    case "section": {
      fieldsForSearchService.section.disabled = prop;
      break;
    }
    case "oblast": {
      fieldsForSearchService.oblast.disabled = prop;
      break;
    }
    case "report": {
      if (prop[0] === "2" && prop[1] === "2") {
        fieldsForSearchService.section.hidden = true;
        fieldsForSearchService.oblast.hidden = true;
      } else {
        fieldsForSearchService.section.hidden = false;
        fieldsForSearchService.oblast.hidden = false;
      }
      break;
    }
    default:
      break;
  }
};

export const getOptionsForField = () => fieldsForSearchService;
